
























































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import Pivot from "@/components/Pivot";
import draggable from "vuedraggable";
import SelectViewDialog from "@/dialogs/SelectView.vue";

import FilterDataSources from "@/components/filters/DataSources.vue";
import FilterAccount from "@/components/filters/Account.vue";
import FilterSalesAgent from "@/components/filters/SalesAgent.vue";
import FilterMultiSelect from "@/components/filters/MultiSelect.vue";
import FilterDateRange from "@/components/filters/DateRange.vue";
import StringFilter from "@/components/filters/String.vue";
import NumberFilter from "@/components/filters/Number.vue";

import AdvancedFilter from "@/components/AdvancedFilter/Operator.vue";

import { NSLog } from "@/helpers/log";
const log = NSLog("view/Pivot");

import { BaseViews } from "@/components/Pivot/index";
import { isArray } from "util";
import { momentTZ as moment } from "@/helpers/moment";
import billing from "@/services/billing";
import Loader from "@/components/loader.vue";
import { Getter, Action, Mutation } from "vuex-class";

@Component({
  components: {
    Loader,
    Pivot,
    draggable,
    SelectViewDialog,

    FilterDataSources,
    FilterAccount,
    FilterMultiSelect,
    FilterDateRange,
    FilterSalesAgent,
    StringFilter,
    NumberFilter,

    AdvancedFilter
  }
})
export default class PivotView extends Vue {
  private get baseViewOptions() {
    const views = [];
    for (const key of Object.keys(BaseViews)) {
      views.push(BaseViews[key]);
    }
    return views;
  }
  private get baseView() {
    if (this.view.BaseViewName) {
      return BaseViews[String(this.view.BaseViewName)];
    }
    return BaseViews[String(this.BaseViewName)];
  }
  get availableFilters() {
    return this.baseView.DatasourceFilters;
  }
  get publicFilters() {
    if (this.loading) {
      return [];
    }
    if (!this.view.visibleFilters || !isArray(this.view.visibleFilters)) {
      return [];
    }
    if (
      !this.baseView.DatasourceFilters ||
      !isArray(this.baseView.DatasourceFilters)
    ) {
      return [];
    }

    return this.view.visibleFilters
      .filter((vf: any) => {
        return this.baseView.DatasourceFilters.find((f: any) => f.name === vf);
      })
      .map((vf: any) => {
        return this.baseView.DatasourceFilters.find((f: any) => f.name === vf);
      })
      .filter((vf: any) => vf);
  }
  get pivotFilters() {
    return [];
  }
  get datasourceFilters() {
    const res: any = {};
    for (const key of Object.keys(this.filters)) {
      const f = this.filters[key];
      if (f && (!isArray(f) || f.length > 0)) {
        res[key] = f;
      }
    }
    return res;
    // should also filter out non datasource filters
  }

  get actions() {
    if (!this.baseView.Actions) {
      return [];
    }
    return this.baseView.Actions;
  }

  get advancedFilterOptions() {
    return {
      keys: this.baseView.Headers,
      operators: [
        { name: "==", id: "=" },
        { name: "!=", id: "!=" },
        { name: ">", id: ">" },
        { name: "<", id: "<" },
        { name: ">=", id: ">=" }
      ]
    };
  }
  @Mutation("setLastErr") public setLastErr: any;

  // ================================= \\
  // =========== BASE VIEW =========== \\
  // ================================= \\
  @Prop() public BaseViewName?: string;

  // ================================= \\
  // ============= VIEW ============== \\
  // ================================= \\
  @Prop() public ViewName?: string;
  public viewID: number = 0;
  public view: any = {
    Name: "",
    Description: "",
    Public: true,
    DataSources: [],
    BaseViewName: "",
    columns: [],
    filters: {}, // datasource filters
    visibleFilters: [],
    customFilters: []
  };

  @Getter("views") public allViews: any;

  @Action("loadViews") public loadViews: any;
  @Action("nav/newView") public newView: any;
  @Action("nav/gotoView") public gotoView: any;
  private editMode = false;
  private valid = false;
  private loading = false;
  private viewSelectDialog = false;

  @Getter("auth/hasPermission") private hasPermission: any;

  // ================================= \\
  // ============ COLUMNS ============ \\
  // ================================= \\
  private availableColumns: any = [];
  private selectedColumns: any = []; // when editing, custom culumns will override

  // ================================= \\
  // ============ FILTERS ============ \\
  // ================================= \\
  private filters: any = {};
  @Watch("view.BaseViewName") public watchViewBaseViewName() {
    this.resetView();
  }
  @Watch("ViewName") public watchViewName() {
    this.editMode = false;
    this.viewSelectDialog = false;
    this.resetView();
  }
  // resets the view to the view definition if available, else take user to default view
  public async resetView() {
    this.loading = true;
    if (!this.ViewName || this.ViewName === "default") {
      // no view specified, go to default
      this.gotoView("default");
    }

    if (this.ViewName === "new") {
      this.viewID = 0;
      this.view.Name = "";
      this.editMode = true;
      this.resetFilters();
    } else {
      // load view an set this.view
      const view = this.allViews.find(
        (v: any) => v.name.toLowerCase() === String(this.ViewName).toLowerCase()
      );
      if (view) {
        this.viewID = view.id;
        this.view = view.definition;
        this.view.Description = this.view.Description || "";
        this.view.Public = this.view.Public || false;
        this.resetColumns();
      } else {
        this.setLastErr(`View ${this.ViewName} not found`);
      }
    }

    this.resetColumns();

    // set loading=false only on next tick. This will force filters to re-create thus applying again
    Vue.nextTick(() => (this.loading = false));
  }
  public resetColumns() {
    this.availableColumns = [];
    this.selectedColumns = [];
    this.baseView.Headers.map((h: any) => {
      if (!this.view.columns.find((cn: any) => h.name === cn)) {
        this.availableColumns.push(JSON.parse(JSON.stringify(h)));
      }
    });
    for (const cn of this.view.columns) {
      const h = this.baseView.Headers.find((hs: any) => hs.name === cn);
      if (h) {
        this.selectedColumns.push(JSON.parse(JSON.stringify(h)));
      }
    }
    // } else {
    //   this.availableColumns = [];
    //   this.selectedColumns = JSON.parse(JSON.stringify(this.baseView.Headers));
    // }
  }
  @Watch("selectedColumns") public watchSelectedColumns() {
    this.view.columns = this.selectedColumns.map((c: any) => c.name);
  }
  public filterName(fn: string) {
    if (!this.baseView || !this.baseView.DatasourceFilters) {
      return `? ${fn} ?`;
    }
    return (
      this.baseView.DatasourceFilters.find((f: any) => f.name === fn) || {
        text: `? ${fn} ?`
      }
    ).text;
  }
  public resetFilters() {
    this.view.filters = {};
  }

  public setFilterValue(filter: any, value: any) {
    if (filter.value) {
      value = filter.value(value);
    }

    // let newFilters: any = {};
    if (!value) {
      // let newFilters: any = {};
      // for (let key in this.view.filters) {
      //   if (filter.name === key) continue;
      //   newFilters[key] = this.view.filters[filter.name];
      // }
      delete this.view.filters[filter.name];
    } else {
      // newFilters = {
      //   ...this.view.filters,
      //   [filter.name]: value
      // };
      this.view.filters[filter.name] = value;
    }
    // this.view.filters = newFilters;
    this.view.filters = { ...this.view.filters };
  }

  public setDatasources(ds: string[]) {
    this.view.DataSources = ds;
  }

  public created() {
    this.loading = true;
    this.view.BaseViewName = this.BaseViewName || "all";
    this.resetView();
    this.loading = false;
  }
  public async saveView() {
    this.loading = true;
    let res;
    try {
      res = await billing.updateView({
        id: this.viewID,
        name: this.view.Name,
        definition: this.view
      });
    } catch (e) {
      log(e);
    }

    this.loading = false;
    if (res.id) {
      this.viewID = res.id;
      this.editMode = false;
      await this.loadViews();
      this.gotoView(this.view.Name);
    }
  }

  public DSNames(datasources?: string[]) {
    if (!datasources) {
      return "";
    }
    const names: any = {
      order: "ORD",
      invoice: "INV",
      subscription: "SUB",
      deliveryitem: "DIT",
      invoiceitem: "IIT",
      communicationlog: "CLOG",
      transaction: "TRAN"
    };

    const res: string[] = [];
    for (const v of datasources) {
      if (names[v]) {
        res.push(names[v]);
      }
    }
    if (res.length === 0) {
      return "";
    }

    return " (" + res.join(", ") + ")";
    // {{item.datasources?'('+item.datasources.join(",")+')':''}}
  }
}
